const Marketplace_EN = {
    auctionTotalAdvanceAmountUSD: 'Total Advance Amount (USD)',
    auctionTotalAdvanceAmountHKD: 'Total Advance Amount (HKD)',
    successAuctionCount: 'Previous Advance',
    remittedAuctionCount: 'Previous Repayment',
    outstandingAuctionCount: 'Outstanding Advance',
    averageLateDay: 'Weighted Average Late Days (Days)',
    earlyRepaymentCounts: 'Early Repayment Counts',
    obligorYearStart: 'Business Relationship with Obligor Since',
    earlyRepaymentCountsAsNegative: '* Early repayment counts as negative',
    'tab-title.receivables': 'Assets',
    'marketplace.all-asset-sold-out': 'All assets have been sold out in this session',
    'marketplace.receivable-table-controller.caption': 'Show assets with',
    'marketplace.receivable-table-controller.is-obligor-notified':
        'Obligor Notified',
    'marketplace.receivable-table-controller.is-insured': 'Insured',
    'marketplace.seller-rating': 'Seller Rating',
    'marketplace.obligor-rating': 'Obligor Rating',
    'marketplace.debt-duration': 'Debt Duration',
    'marketplace.due-date': 'Due Date',
    'marketplace.asset-number': 'Asset Number',
    'marketplace.insurance': 'Trade Credit Insurance',
    'marketplace.obligor-notified': 'Obligor Notified',
    'marketplace.industry': 'Industry',
    'marketplace.product-description': 'Product Description',
    'marketplace.relationship-year-start': 'Trading with Seller Since',
    'marketplace.rating': 'Rating',
    'marketplace.member-since': 'Member Since',
    'marketplace.seller-report': 'Seller Report',
    'marketplace.seller-description': 'Seller Description',
    'marketplace.employee-size': 'Employee Headcount',
    'marketplace.year-established': 'Established Since',
    'marketplace.corporate-domicile': 'Corporate Domicile',
    'marketplace.seller-number': 'Seller Number',
    'marketplace.obligor-number': 'Obligor Number',
    'marketplace.obligor-company-name': 'Obligor Name',
    'marketplace.obligor-name': 'Obligor Name',
    'marketplace.advance-amount': 'Advance Amount',
    'marketplace.remaining-amount-for-purchase': 'Remaining Amount for Purchase',
    'marketplace.business-nature': 'Business Nature',
    'marketplace.basis-point': 'Basis Point',
    'marketplace.no-live-asset': 'No Available Assets',
    'marketplace.tooltip.obligor-is-notified': 'Obligor is notified',
    'marketplace.tooltip.obligor-is-not-notified': 'Obligor is not notified',
    'marketplace.tooltip.insured': 'Asset is insured',
    'marketplace.tooltip.uninsured': 'Asset is uninsured',
    'marketplace.tooltip.seller-rating': 'Seller rating',
    'marketplace.tooltip.obligor-rating': 'Obligor rating',
    'marketplace.tooltip.funder-flow-control': 'Fund Flow Control',
    'marketplace.tooltip.inventory-control': 'Inventory Control',
    'marketplace.button-buy-now': 'Buy Now',
    'marketplace.advance-date': 'Advance Date',
    'marketplace.credit-enhancementList': 'Credit Enhancement',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_LLPAY': 'LianLian Pay',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_WF': 'WorldFirst',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_PP': 'PingPong',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_SKYEE': 'Skyee',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_ONERWAY': 'OnerWay',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_SUNRATE': 'Sunrate',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_IPLS': 'Ipaylinks Limited',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_CGLINKS': 'CoGoLinks',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_KPAY': 'KPay',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_AWX': 'Airwallex',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_PDD': 'Pinduoduo',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_BINDO': 'Bindo',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_OTHS': 'Others',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_ASB': 'Asiabill',
    'marketplace.credit-enhancementList.INVENTORY_CONTROL_WINIT': 'Winit',
    'marketplace.credit-enhancementList.INVENTORY_CONTROL_ZONGTENG': 'Zongteng',
    'marketplace.repayment-date': 'Repayment Date',
    'marketplace.gross-gain-estimation.title': 'Gross Gain Estimation',
    'marketplace.gross-gain-estimation.ttl-advance-amount':
        'Your Advance Amount',
    'marketplace.gross-gain-estimation.debt-duration': 'Debt Duration',
    'marketplace.gross-gain-estimation.basis-point': 'Basis Point',
    'marketplace.gross-gain-estimation.due-date': 'Due Date',
    'marketplace.gross-gain-estimation.summary-title': 'Estimated Gross Gain',
    'marketplace.gross-gain-estimation.caption':
        'Estimated Gains is a rough estimation for reference only. It does not guarantee the actual return.',
    'marketplace.asset-portion.title': 'Asset Portion',
    'marketplace.buy-now-modal.title': 'Confirm To Buy This Asset?',
    'marketplace.buy-now-modal.caption':
        'Before you purchase this asset, make sure you read and understand all the information about this asset. You may buy certain portions of this asset instead of entire asset which may help you to diversify risks and build a better asset portfolio.',
    'marketplace.buy-now-modal.over-portfolio-warning':
        'Our system found that you have already purchased over 10% of your total assets on the same Seller’s Assets, this may increase your risk but you can proceed the purchase on your own account.',
    'marketplace.buy-now-modal.over-portfolio-warning-title':
        'Unhealthy Asset Portfolio Reminder',
    'marketplace.buy-now-modal.auction-criteria-warning-title':
        'Auction Criteria Warning',
    'marketplace.buy-now-modal.over-max-exposure':
        'Max. Exposure',
    'marketplace.buy-now-modal.over-max-overdue':
        'Max. Overdue',
    'marketplace.buy-now-modal.credit-enhancement-not-match':
        'Credit Enhancement',
    'marketplace.buy-now-modal.under-min-duration':
        'Min. Duration',
    'marketplace.buy-now-modal.over-max-duration':
        'Max. Duration',
    'marketplace.asset-detail-title': 'Asset Details',
    'marketplace.asset-detail-tabs.overview': 'Overview',
    'marketplace.asset-detail-tabs.seller-profile': 'Seller Profile',
    'marketplace.asset-detail-title.asset': 'Asset',
    'marketplace.asset-detail.asset-overview': 'Asset Overview',
    'marketplace.detail.card.asset-number': 'Asset Number',
    'marketplace.detail.card.receivables': 'Receivables',
    'marketplace.detail.card.advance-percentage': 'Advance Percentage',
    'marketplace.detail.card.advance-amount': 'Advance Amount',
    'marketplace.detail.card.debt-duration': 'Debt Duration',
    'marketplace.detail.card.credit-enhancementList': 'Credit Enhancement',
    'marketplace.detail.card.key-date': 'Key Dates',
    'marketplace.receivable-detail.fill-now': 'Purchase',
    'marketplace.asset-detail.seller-overview': 'Seller Overview',
    'marketplace.asset-detail.obligor-overview': 'Obligor Overview',
    'marketplace.asset-detail.key-figure': 'Key Figures',
    'marketplace.asset-detail.last-updated': 'Last Updated',
    'marketplace.asset-detail.finance-ratio': 'Financial Ratio',
    'marketplace.asset-detail.title-seller': 'Seller',
    'marketplace.asset-detail.title-seller-obligor': 'Seller-Obligor',
    'marketplace.asset-detail.title-seller-stats':
        'Seller and Seller-Obligor Statistics',
    'marketplace.asset-detail.previous-advance-title': 'Previous Advance',
    'marketplace.asset-detail.live-asset-title': 'Live Asset',
    'marketplace.purchase-asset-result.ERROR_INVALID_AMOUNT': 'Invalid amount to be purchased',
    'marketplace.purchase-asset-result.ERROR_NOT_PURCHASABLE': 'Current asset is not available',
    'marketplace.purchase-asset-result.ERROR_BEING_PURCHASE': 'Other user(s) are purchasing this asset. Please try again.',
    'marketplace.purchase-asset-result.ERROR_AMOUNT_EXCEED': 'Purchased amount must be smaller than or equal to remaining amount for purchase.',
    'marketplace.purchase-asset-result.FUNDER_ERR_INVALID_PARAM': 'Invalid input.',
    'marketplace.purchase-asset-result.FUNDER_ERR_INTERNAL_SERVICE': 'Asset service is temporary unavailable. Please contact Qupital or try again later.',
    'marketplace.purchase-asset-result.title': 'Purchase Asset Result',
    'marketplace.purchase-asset-result.FUNDER_ERR_UNAVAILABLE_ASSET':
        'Asset is not available',
    'marketplace.purchase-asset-result.FUNDER_ERR_INSUFFICIENT_BALANCE':
        'Insufficient buying power',
    'marketplace.purchase-asset-result.FUNDER_ERR_SUB_ASSET_SOLD':
        'Some asset(s) are not available',
    'marketplace.purchase-asset-result.OK': 'Purchase order is executed',
    'marketplace.title.submit-time': 'Submit Time',
    'marketplace.title.due-date': 'Due Date',
    'marketplace.title.expected-payment-date': 'Expected Payment Date',
    'marketplace.title.expected-repurchase-date': 'Expected Repurchase Date',
    'marketplace.title.live-time': 'Live Time',
    'marketplace.overview.seller-report-unavailable': 'Seller report is not available',
    'marketplace.purchase-modal.title': 'Purchase Order',
    'marketplace.purchase-modal.loading-caption': 'We are processing your purchase order.',
    'marketplace.asset-block.available-asset': 'Available Assets',
    'marketplace.asset-block.your-orders': 'Your Orders',
    'marketplace.asset-block.unavailable-asset': 'Unavailable Assets',
    'marketplace.asset-block.no-asset': 'No assets',
    "marketplace.available-amount": "Remaining amount for purchase",
    "marketplace.purchase-amount": "Amount to be purchased",
};

const Marketplace_ZH_TW = {
    auctionTotalAdvanceAmountUSD: '賣方總融資金額 (美元)',
    auctionTotalAdvanceAmountHKD: '賣方總融資金額 (港元)',
    successAuctionCount: '賣方成功融資資產',
    remittedAuctionCount: '賣方已付款資產',
    outstandingAuctionCount: '賣方待付款資產',
    averageLateDay: '賣方加權平均遲還日子 (日)',
    earlyRepaymentCounts: '賣方提早僨還資產數目',
    obligorYearStart: '首次交易年份',
    earlyRepaymentCountsAsNegative: '* 提早償還日數會以負數計算',
    'tab-title.receivables': '資產',
    'marketplace.all-asset-sold-out': '是次所有資產已售罄',
    'marketplace.receivable-table-controller.caption': '過濾選項',
    'marketplace.receivable-table-controller.is-obligor-notified':
        '已通知付款方',
    'marketplace.receivable-table-controller.is-insured': '已投保',
    'marketplace.seller-rating': '賣方在平台的評級',
    'marketplace.obligor-rating': '付款方在平台的評級',
    'marketplace.debt-duration': '預計融資日數',
    'marketplace.due-date': '到期日',
    'marketplace.asset-number': '資產編號',
    'marketplace.insurance': '出口信用保險',
    'marketplace.obligor-notified': '已通知付款方',
    'marketplace.industry': '行業',
    'marketplace.product-description': '產品描述',
    'marketplace.relationship-year-start': '與賣方開始合作的年份',
    'marketplace.rating': '評級',
    'marketplace.member-since': '加入平台年份',
    'marketplace.seller-report': '賣方報告',
    'marketplace.seller-description': '賣方公司簡介',
    'marketplace.employee-size': '員工數目',
    'marketplace.year-established': '創立年份',
    'marketplace.corporate-domicile': '公司所在地',
    'marketplace.seller-number': '賣方編號',
    'marketplace.obligor-number': '付款方編號',
    'marketplace.obligor-company-name': '付款方名稱',
    'marketplace.obligor-name': '付款方名稱',
    'marketplace.advance-amount': '融資金額',
    'marketplace.remaining-amount-for-purchase': '剩餘購買金額',
    'marketplace.business-nature': '業務性質',
    'marketplace.basis-point': '基點',
    'marketplace.no-live-asset': '沒有拍賣中的資產',
    'marketplace.tooltip.obligor-is-notified': '已通知付款方',
    'marketplace.tooltip.obligor-is-not-notified': '沒有通知付款方',
    'marketplace.tooltip.insured': '已保險保障資產',
    'marketplace.tooltip.uninsured': '並未受保資產',
    'marketplace.tooltip.seller-rating': '賣方在平台的評級',
    'marketplace.tooltip.obligor-rating': '付款方在平台的評級',
    'marketplace.tooltip.funder-flow-control': '資金流控制',
    'marketplace.tooltip.inventory-control': '控貨',
    'marketplace.button-buy-now': '購買',
    'marketplace.advance-date': '付款日期',
    'marketplace.repayment-date': '回款日期',
    'marketplace.gross-gain-estimation.title': '預期總收益',
    'marketplace.gross-gain-estimation.ttl-advance-amount': '您的本金',
    'marketplace.gross-gain-estimation.debt-duration': '融資日數',
    'marketplace.gross-gain-estimation.basis-point': '基點',
    'marketplace.gross-gain-estimation.due-date': '到期日',
    'marketplace.gross-gain-estimation.summary-title': '預期總收益',
    'marketplace.gross-gain-estimation.caption':
        '預期總收益只提參考，實質收益並不一定等於總收益。',
    'marketplace.asset-portion.title': '資產部分',
    'marketplace.buy-now-modal.title': '確認購買資產?',
    'marketplace.buy-now-modal.caption':
        '在您購買相關資產前, 請先閱讀並了解相關資產訊息。您可以購買部份而非整個資產來幫助減低相關風險。',
    'marketplace.buy-now-modal.over-portfolio-warning':
        '本平台發現相關賣方資產已佔了您的投資組合多於10%。相關操作可能會提高您的風險但您仍可以繼續購買。',
    'marketplace.buy-now-modal.over-portfolio-warning-title':
        '不健康投資組合風險警告',
    'marketplace.asset-detail-title': '資產詳情',
    'marketplace.asset-detail-tabs.overview': '概覽',
    'marketplace.asset-detail-tabs.seller-profile': '賣方資料',
    'marketplace.asset-detail-title.asset': '資產',
    'marketplace.asset-detail.asset-overview': '資產概覽',
    'marketplace.detail.card.asset-number': '資產編號',
    'marketplace.detail.card.receivables': '應收賬款',
    'marketplace.detail.card.advance-percentage': '貼現率',
    'marketplace.detail.card.advance-amount': '融資金額',
    'marketplace.detail.card.debt-duration': '融資日數',
    'marketplace.detail.card.credit-enhancementList': '增信',
    'marketplace.detail.card.key-date': '關鍵日期',
    'marketplace.receivable-detail.fill-now': '購買',
    'marketplace.asset-detail.seller-overview': '賣方概覽',
    'marketplace.asset-detail.obligor-overview': '付款方概覽',
    'marketplace.asset-detail.key-figure': '關鍵數據',
    'marketplace.asset-detail.last-updated': '最後更新',
    'marketplace.asset-detail.finance-ratio': '財務比率',
    'marketplace.asset-detail.title-seller': '賣方',
    'marketplace.asset-detail.title-seller-obligor': '賣方-付款方',
    'marketplace.asset-detail.title-seller-stats': '賣方與賣方-付款方數額統計',
    'marketplace.asset-detail.previous-advance-title': '賣方成功拍賣資產',
    'marketplace.asset-detail.live-asset-title': '賣方拍賣中資產',
    'marketplace.purchase-asset-result.title': '購買資產結果',
    'marketplace.purchase-asset-result.ERROR_INVALID_AMOUNT': '輸入可購買金額錯誤。',
    'marketplace.purchase-asset-result.ERROR_NOT_PURCHASABLE': '資產已下架。',
    'marketplace.purchase-asset-result.ERROR_BEING_PURCHASE': '其他用戶正在購買，請重新提交指令。',
    'marketplace.purchase-asset-result.ERROR_AMOUNT_EXCEED': '輸入可購買金額過大，請重新輸入。',
    'marketplace.purchase-asset-result.FUNDER_ERR_INVALID_PARAM': '輸入資料錯誤。',
    'marketplace.purchase-asset-result.FUNDER_ERR_INTERNAL_SERVICE': '服務出現問題，請聯絡本公司或稍後再試。',
    'marketplace.purchase-asset-result.FUNDER_ERR_UNAVAILABLE_ASSET':
        '資產暫時不能購買',
    'marketplace.purchase-asset-result.FUNDER_ERR_INSUFFICIENT_BALANCE':
        '購買力不足',
    'marketplace.purchase-asset-result.FUNDER_ERR_SUB_ASSET_SOLD':
        '部份子資產購買失敗',
    'marketplace.purchase-asset-result.OK': '已執行購買資產操作',
    'marketplace.title.submit-time': '提交時間',
    'marketplace.title.due-date': '到期日',
    'marketplace.title.expected-payment-date': '預期回款日期',
    'marketplace.title.expected-repurchase-date': '預期回購日期',
    'marketplace.title.live-time': '平台上架日期',
    'marketplace.overview.seller-report-unavailable': '暫時未能提供賣方報告',
    'marketplace.purchase-modal.title': '訂單指示',
    'marketplace.purchase-modal.loading-caption': '正在處理您的訂單指示。',
    'marketplace.credit-enhancementList': '增信',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_LLPAY': '連連支付',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_WF': '萬里匯',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_PP': 'PingPong',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_SKYEE': 'Skyee',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_ONERWAY': '萬唯',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_SUNRATE': '尋匯',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_IPLS': '艾貝盈',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_CGLINKS': '结行国际',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_KPAY': 'KPay',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_AWX': '空中雲匯',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_PDD': '拼多多',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_BINDO': 'Bindo',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_OTHS': '其他',
    'marketplace.credit-enhancementList.FUND_FLOW_CONTROL_ASB': 'Asiabill',
    'marketplace.credit-enhancementList.INVENTORY_CONTROL_WINIT': '萬邑通',
    'marketplace.credit-enhancementList.INVENTORY_CONTROL_ZONGTENG': '縱騰',
    'marketplace.asset-block.available-asset': '可購買資產',
    'marketplace.asset-block.your-orders': '您已購買資產',
    'marketplace.asset-block.unavailable-asset': '已被其他投資者購買的資產',
    'marketplace.asset-block.no-asset': '沒有資產',
    "marketplace.available-amount": "可購買金額",
    "marketplace.purchase-amount": "購買金額",
};

export { Marketplace_EN, Marketplace_ZH_TW };
